module.exports = __webpack_public_path__ + "img/snapchat-sm.430955c7.svg";